module.exports = __webpack_public_path__ + "static/media/pic1.321ba415.jpg";